import { ADD_MAIN_MODULE, UserAction, UserActionRequest } from "./types";


const initialStateUserAction: UserActionRequest = {
    mainModuleId: '',
}

  export function UserReducer(
    state = initialStateUserAction,
    action: UserAction
  ): UserActionRequest {
    switch (action.type) {
      case ADD_MAIN_MODULE:
        return {
          ...state,
          mainModuleId: action.payload
        };
      
      default:
        return state;
    }
  }